

import { Container, Typography } from '@mui/material';
import { Box } from '@mui/system';


export const NotFound = () => {
    return <>
        <Container maxWidth={false}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}><img width={200} height={100} src='./assets/cdx_logo_v.svg' /></Box>
            <Typography sx={{ textAlign: 'center' }} variant='h3'>Code 404 - Introuvable</Typography>
            <Typography style={{ textAlign: 'center' }}>Oops, élément ou page introuvable :(</Typography>
        </Container>
    </>;
};
